export default "__VITE_ASSET__xtDLvNKD__"